<template>
  <v-container class="p-2">
    <v-card class="pa-2">
      <loading
        :active="isload"
        :is-full-page="false"
        :opacity="0.7"
        color="#ff6b00"
      />
      <v-card-title class="pa-0 ps-3"> Personal Details </v-card-title>
      <v-divider></v-divider>
      <v-form ref="complincmanual" v-model="valid" lazy-validation>
        <v-row class="ms-1 me-1 mt-1" justify="center">
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0"> First Name </label>
            <v-text-field
              :rules="first_nameRules"
              v-model="customerINDdata.first_name"
              dense
              outlined
              placeholder="First Name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="labelFontsize my-0"> Middle Name </label>
            <v-text-field
              dense
              outlined
              v-model="customerINDdata.middle_name"
              placeholder="Middle Name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0"> Last Name </label>
            <v-text-field
              :rules="last_nameRules"
              v-model="customerINDdata.last_name"
              dense
              outlined
              placeholder="Last Name"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="ms-1 me-1 mt-1" justify="center">
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0"> Date Of Birth </label>
            <v-text-field
              :max="maxDate"
              @change="ValidateAge"
              :rules="dobRules"
              dense
              v-model="customerINDdata.dob"
              outlined
              type="date"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0">Nationality</label>
            <v-autocomplete
              v-model="customerINDdata.nationality_code"
              :items="dropdown.nationalityList"
              :rules="nationalityRules"
              dense
              outlined
              placeholder="Nationality"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0"> Gender </label>
            <v-autocomplete
              dense
              v-model="customerINDdata.gender"
              :items="genderOptins"
              :rules="genderRules"
              outlined
              placeholder="Gender"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="ms-1 me-1 mt-1" justify="center">
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0">
              Country Of Birth
            </label>
            <v-autocomplete
              dense
              :items="dropdown.countryOptions"
              v-model="customerINDdata.country_of_birth"
              outlined
              :rules="CountryofbirthRules"
              placeholder="Country Of Birth"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0"> Email Id </label>
            <v-text-field
              dense
              outlined
              v-model="customerINDdata.email_id"
              :rules="emailRules"
              placeholder="Email Id"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0"> Address </label>
            <v-text-field
              dense
              outlined
              v-model="customerINDdata.address"
              :rules="addressRule"
              placeholder="Address"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="ms-1 me-1 mt-1" justify="center">
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0"> Country </label>
            <v-autocomplete
              :items="dropdown.countryOptions"
              v-model="customerINDdata.country_code"
              disabled
              dense
              outlined
              @change="getStates()"
              :rules="CountryRules"
              placeholder="Country"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0"> State </label>
            <v-autocomplete
              dense
              outlined
              @change="getCities()"
              v-model="customerINDdata.state_code"
              :items="dropdown.state_options"
              :rules="StateRules"
              placeholder="State"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0">City</label>
            <v-autocomplete
              v-if="haveCities"
              dense
              v-model="customerINDdata.city_code"
              :items="dropdown.city_options"
              :rules="CityRules"
              outlined
              placeholder="City"
            ></v-autocomplete>
            <v-text-field
              v-else
              dense
              outlined
              v-model="customerINDdata.city_code"
              :rules="CityRules"
              placeholder="Enter City"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="ms-1 me-1 mt-1" justify="center">
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0"> Postal Code </label>
            <v-autocomplete
              dense
              v-model="customerINDdata.zip_code"
              :items="dropdown.zipcodes"
              outlined
              :rules="pincodeRule"
              placeholder="Postal Code"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="labelFontsize required my-0">Contact Number </label>
            <v-text-field
              placeholder="Enter Contact Number"
              dense
              outlined
              v-model="customerINDdata.mobile_number"
              :rules="contactNumbrules"
              prefix="+60"
              required
              type="number"
              hide-spin-buttons
              :hint="'+60 xx xxx xxxx'"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0"> Occupation </label>
            <v-autocomplete
              dense
              outlined
              v-model="customerINDdata.occupation_code"
              :items="dropdown.occupation_list"
              :rules="occupationRules"
              placeholder="Occupation"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="ms-1 me-1 mt-1" justify="start">
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0"> Employer</label>
            <v-text-field
              dense
              outlined
              v-model="customerINDdata.employer_name"
              :rules="employerRules"
              placeholder="Employer"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0">
              Source Of Income
            </label>
            <v-autocomplete
              dense
              v-model="customerINDdata.source_of_fund_code"
              :items="dropdown.sourceofFunds_list"
              outlined
              :rules="sourceofFundRules"
              placeholder="Source Of Income"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="labelFontsize my-0"> Referral Code</label>
            <v-text-field
              dense
              outlined
              :loading="isgetspname"
              hide-details
              v-model="customerINDdata.sp_referral_code"
              @input="getReferralName(customerINDdata.sp_referral_code)"
              placeholder="Referral Code"
            ></v-text-field>
            <p
              v-if="customerINDdata.sp_referral_code"
              class="caption pa-0 ma-0 ps-2"
              :class="isavalaible.success ? 'success--text' : 'error--text'"
            >
              <v-icon
                class="me-2"
                x-small
                :color="isavalaible.success ? 'success' : 'error'"
                >mdi-check-circle</v-icon
              >{{ isavalaible.message }}
            </p>
          </v-col>
        </v-row>
        <v-card-title class="pa-0 ps-3"> KYC Details </v-card-title>
        <v-divider></v-divider>

        <v-row class="ms-1 me-1 mt-1" justify="start">
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0"> ID Type </label>
            <v-select
              :menu-props="{ bottom: true, offsetY: true }"
              v-model="customerINDdata.id_type_code"
              :rules="validations.id_proofrules"
              :items="dropdown.ID_types"
              outlined
              required
              :placeholder="$t('idtype_select_placeholder')"
              dense
            ></v-select>
          </v-col>

          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0"> ID Number </label>
            <v-text-field
              :placeholder="$t('id_number_placeholder')"
              v-model="customerINDdata.id_number"
              :rules="validations.id_numberRules"
              outlined
              required
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" lg="4" xs="12">
            <label
              :class="
                customerINDdata.id_type_code === '4'
                  ? 'required labelFontsize my-0'
                  : 'labelFontsize my-0'
              "
            >
              Issue Location
            </label>
            <v-autocomplete
              v-model="customerINDdata.id_issue_country_code"
              :items="dropdown.countryOptions"
              :disabled="
                customerINDdata.id_type_code === '1' ||
                customerINDdata.id_type_code === '2'
              "
              :rules="
                customerINDdata.id_type_code === '4'
                  ? validations.issue_locationRules
                  : []
              "
              :placeholder="$t('Location')"
              dense
              outlined
              required
            />
          </v-col>
        </v-row>
        <v-row class="ms-1 me-1 mt-1" justify="start">
          <v-col
            cols="12"
            md="4"
            lg="4"
            xs="12"
            v-if="
              customerINDdata.id_type_code != '1' &&
              customerINDdata.id_type_code != '2'
            "
          >
            <label class="required labelFontsize my-0"> Issue Date </label>
            <v-text-field
              v-model="customerINDdata.id_issue_date"
              :rules="validations.issuedaterules"
              dense
              required
              outlined
              type="date"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
            lg="4"
            xs="12"
            v-if="
              customerINDdata.id_type_code != '1' &&
              customerINDdata.id_type_code != '2'
            "
          >
            <label class="required labelFontsize my-0">
              {{ $t("expiryDate") }}</label
            >
            <v-text-field
              v-model="customerINDdata.id_expire_date"
              :rules="validations.expDateRules"
              dense
              outlined
              required
              type="date"
            />
          </v-col>
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0">
              {{ $t("IDFirstPage") }}</label
            >

            <v-file-input
              v-model="imageData.frontPage"
              dense
              accept="image/png, image/jpeg, image/bmp"
              :placeholder="$t('idtype_first_page_placeholder')"
              :rules="validations.firstpage_rules"
              outlined
              ref="idfirstfile"
              required
              prepend-icon=""
              @change="
                genrateURL('frontPageUrl', imageData.frontPage, 'frontPage')
              "
            >
              <template v-slot:append>
                <v-icon
                  aria-hidden="false"
                  class="color-primary"
                  @click="openIdfirst"
                >
                  mdi-cloud-upload
                </v-icon>
              </template>

              <template v-slot:append-outer>
                <v-img
                  v-if="imageData.frontPageUrl"
                  class="ml-1"
                  max-height="40"
                  max-width="50"
                  :src="imageData.frontPageUrl"
                  @click="handleImageViewer(imageData.frontPageUrl)"
                />
              </template>
            </v-file-input>
          </v-col>

          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="labelFontsize ma-0 pa-0">{{
              $t("IDLastPage")
            }}</label>
            <v-file-input
              v-model="imageData.backpage"
              dense
              accept="image/png, image/jpeg, image/bmp"
              :placeholder="$t('idtype_last_page_placeholder')"
              outlined
              ref="idlastfile"
              required
              prepend-icon=""
              @change="
                genrateURL('backpageUrl', imageData.backpage, 'backpage')
              "
            >
              <template v-slot:append>
                <v-icon
                  aria-hidden="false"
                  @click="openIdlast"
                  class="color-primary"
                >
                  mdi-cloud-upload
                </v-icon>
              </template>

              <template v-slot:append-outer>
                <v-img
                  v-if="imageData.backpageUrl"
                  class="ml-1"
                  max-height="40"
                  max-width="50"
                  :src="imageData.backpageUrl"
                  @click="handleImageViewer(imageData.backpageUrl)"
                />
              </template>
            </v-file-input>
          </v-col>
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize ma-0 pa-0">{{
              $t("Selfy")
            }}</label>
            <v-file-input
              v-model="imageData.profile_pic"
              dense
              accept="image/png, image/jpeg, image/bmp"
              :placeholder="$t('idtype_selfy_page_placeholder')"
              :rules="validations.selfy_rules"
              outlined
              ref="selfiefile"
              required
              prepend-icon=""
              @change="
                genrateURL(
                  'profile_picUrl',
                  imageData.profile_pic,
                  'profile_pic'
                )
              "
            >
              <template v-slot:append>
                <v-icon aria-hidden="false" class="color-primary" @click="open">
                  mdi-cloud-upload
                </v-icon>
              </template>

              <template v-slot:append-outer>
                <v-img
                  v-if="imageData.profile_picUrl"
                  class="ml-1"
                  max-height="40"
                  max-width="50"
                  :src="imageData.profile_picUrl"
                  @click="handleImageViewer(imageData.profile_picUrl)"
                />
              </template>
            </v-file-input>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-col cols="12" md="12">
          <v-row class="d-flex justify-end">
            <v-btn
              depressed
              small
              class="ma-2 me-4 text-capitalize"
              color="error"
              @click="cancel()"
            >
              <v-icon small class="me-2">mdi-close-circle-outline</v-icon>Cancel
            </v-btn>
            <v-btn
              depressed
              color="primary"
              small
              @click="saveData()"
              class="ma-2 mb-10 text-capitalize rounded"
            >
              <v-icon small class="me-2">mdi-content-save-check-outline</v-icon
              >Submit
            </v-btn>
          </v-row>
        </v-col>
      </v-form>
    </v-card>
    <image-viewer
      :showDialog="isImageViewer"
      :picture="{
        PicHeight: '435',
        PicWidth: 600,
        Pic: imageViewerUrl,
      }"
      @closeImageViewer="handleCloseImageViewer"
    ></image-viewer>
  </v-container>
</template>
<script>
import alerts from "@/mixins/alerts";
import imageViewer from "../../tools/imageViewer.vue";
import Loading from "vue-loading-overlay";
import { i18n as $ } from "../../../locale/index";
import { findDatePrevious } from "@/utils/helper";
import { validation } from "@/utils/validationCopy.js";
import { checkNumber } from "@/utils/contactNumber/formatNumber";
import agentService from "@/services/agentService/AgentService.js";
import commonService from "@/services/AgentCommonService/commonService.js";
export default {
  mixins: [alerts],
  name: "Customer Individual",
  data: () => ({
    ...validation,
    checkNumber,
    isImageViewer: false,
    imageViewerUrl: "",
    isload: false,
    valid: true,
    haveCities: true,
    isgetspname: false,
    isavalaible: {},
    maxDate: "",
    minDate: "",
    show_overlay: false,
    genderOptins: ["Male", "Female"],
    customerINDdata: {
      first_name: "",
      middle_name: "",
      last_name: "",
      email_id: "",
      mobile_number: "",
      dob: null,
      gender: "Male",
      employer_name: "",
      address: "",
      country_code: "",
      nationality_code: "",
      state_code: "",
      city_code: "",
      zip_code: "",
      occupation_code: "",
      source_of_fund_code: "",
      sp_referral_code: "",
      id_issue_country_code: "",
      id_type_code: "",
      id_number: "",
      id_expire_date: null,
      id_issue_date: null,
      id_issue_place: "",
      interview_date: null,
      interview_city: "",
      country_of_birth: "",
      partner_id: "",
      user_type: "IND",
      frontPage: null,
      backpage: null,
      profile_pic: null,
    },
    imageData: {
      frontPage: null,
      frontPageUrl: null,
      backpage: null,
      backpageUrl: null,
      profile_pic: null,
      profile_picUrl: null,
    },
    validations: {
      selfy_rules: [(v) => !!v || $.t("file_select_placeholder")],
      firstpage_rules: [(v) => !!v || $.t("file_select_placeholder")],
      issuedaterules: [(v) => !!v || $.t("issueDateMsg1")],
      issue_locationRules: [(v) => !!v || $.t("issue_location_placeholder")],
      expDateRules: [(v) => !!v || $.t("expiryDateMsg1")],
      id_proofrules: [(v) => !!v || $.t("idtypeMsg1")],
      id_numberRules: [(v) => !!v || $.t("idnumberMsg1")],
      interviewData: [(v) => !!v || $.t("interviewDate")],
      interviewTime: [(v) => !!v || $.t("interviewTime")],
    },
    dropdown: {
      nationalityList: [],
      countryOptions: [],
      state_options: [],
      city_options: [],
      occupation_list: [],
      zipcodes: [],
      sourceofFunds_list: [],
      ID_types: [],
    },
    country_Info: {},
  }),
  mounted() {
    this.customerINDdata.partner_id = sessionStorage.getItem("partner_id");
    this.country_Info = JSON.parse(sessionStorage.getItem("partner_country"));
    this.customerINDdata.country_code = this.country_Info.iso_alpha3;
    this.getcountryList();
    this.getOccupation();
    this.getzipcodes();
    this.getStates();
    this.getSourceOfFunds();
    this.getparameterdropdowns("DOC");
    this.maxDate = findDatePrevious(new Date(), 18);
  },
  components: {
    // VuePhoneNumberInput,
    Loading,
    imageViewer,
  },
  watch: {
    "customerINDdata.id_type_code"(val) {
      if (val == "1" || val == "2") {
        this.customerINDdata.id_issue_country_code =
          this.country_Info.iso_alpha3;
      } else {
        this.customerINDdata.id_issue_country_code = "";
      }
    },
  },
  methods: {
    open() {
      this.$refs.selfiefile.$el.querySelector("input").click();
    },
    openIdlast() {
      this.$refs.idlastfile.$el.querySelector("input").click();
    },
    openIdfirst() {
      this.$refs.idfirstfile.$el.querySelector("input").click();
    },
    cancel() {
      this.$refs.complincmanual.reset();
    },
    ValidateAge(value, e) {
      console.log(value, e);

      if (!value) {
        this.isDobError = false;
      } else {
        this.isDobError = !(value <= this.maxDate);
      }
    },
    handleCloseImageViewer() {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = "";
    },
    handleImageViewer(url) {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = url;
    },
    genrateURL(keyField, value, assignKey) {
      if (!keyField) return;
      if (!value) {
        this.imageData[`${keyField}`] = null;
        this.customerINDdata[`${assignKey}`] = null;
      } else {
        this.imageData[`${keyField}`] = URL.createObjectURL(value);
        this.customerINDdata[`${assignKey}`] = value;
      }
    },
    async saveData() {
      if (this.customerINDdata.sp_referral_code) {
        if (this.isavalaible.success) {
          this.CreateCustomer();
        }
      } else {
        this.CreateCustomer();
      }
    },
    async CreateCustomer() {
      const validate = this.$refs.complincmanual.validate();
      const Num_format = this.checkNumber(this.customerINDdata.mobile_number);
      this.customerINDdata.mobile_number = Num_format;
      if (validate) {
        console.log(`customerINDdata: ${JSON.stringify(this.customerINDdata)}`);
        this.isload = true;
        try {
          const responseData = await agentService.addIndCustomer(
            this.customerINDdata
          );
          if (responseData && responseData.data.status_code === 200) {
            this.showAlertSuccess(responseData.data.message);
            if (this.customerINDdata.frontPage) {
              this.uploadCustDocs(
                responseData.data.data[0].login_id,
                "FRONT_PAGE",
                this.customerINDdata.frontPage
              );
            }
            if (this.customerINDdata.backpage) {
              this.uploadCustDocs(
                responseData.data.data[0].login_id,
                "BACK_PAGE",
                this.customerINDdata.backpage
              );
            }
            if (this.customerINDdata.frontPage) {
              this.uploadCustDocs(
                responseData.data.data[0].login_id,
                "FACE_IMAGE",
                this.customerINDdata.profile_pic
              );
            }
            this.isload = false;
            this.$refs.complincmanual.reset();
          } else {
            this.isload = false;
            this.showAlertError(responseData.data.message);
          }
        } catch (error) {
          this.isload = false;
          console.log(error.response);
          this.showAlertError("Something went wrong please try again later.");
        }
        this.customerINDdata.country_code = this.country_Info.iso_alpha3;
      }
    },
    async uploadCustDocs(id, doc_type, doc) {
      let fileData = new FormData();
      fileData.append("document", doc);
      try {
        const response = await agentService.uploadCustDocs(
          id,
          doc_type,
          fileData
        );
        if (response.data.status_code === 200) {
          console.log("Logo Update");
        } else {
          this.showAlertError(response.data.message);
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getcountryList() {
      try {
        const responseData = await commonService.getCountryBirthList();
        if (responseData.data.status_code === 200) {
          this.dropdown.countryOptions = responseData.data.data.map((i) => {
            return { text: i.country_name, value: i.iso_alpha3 };
          });
          this.dropdown.nationalityList = responseData.data.data.map((i) => {
            return { text: i.nationality, value: i.iso_alpha3 };
          });
        }

        console.log("countrys", responseData);
      } catch (e) {
        console.error(e);
        this.CountryList = [];
      }
    },
    async getStates() {
      this.dropdown.city_options = [];
      this.customerINDdata.city_code = "";
      this.haveCities = true;
      console.log(this.customerINDdata.country_code);

      try {
        const responseData = await commonService.getStatesList(
          this.customerINDdata.country_code
        );
        if (responseData.data.status_code === 200) {
          this.dropdown.state_options = responseData.data.data.map((i) => {
            return {
              text: i.name,
              value: i.state_code,
            };
          });
        }

        console.log("States", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getReferralName(code) {
      this.isgetspname = true;
      try {
        const responseData = await agentService.getReferralName(code);
        if (responseData.data.status_code === 200) {
          this.isgetspname = false;
          this.isavalaible = {
            success: true,
            message: responseData.data.data[0].name,
          };
        } else {
          this.isgetspname = false;
          this.isavalaible = {
            success: false,
            message: responseData.data.message,
          };
        }
        console.log("States", responseData);
      } catch (e) {
        this.isgetspname = false;
        console.error(e);
      }
    },
    async getCities() {
      this.dropdown.city_options = [];
      this.customerINDdata.city_code = "";
      this.haveCities = true;
      if (!this.customerINDdata.country_code || !this.customerINDdata.state_code) return;
      try {
        const responseData = await commonService.getCitiesList(
          this.customerINDdata.country_code,
          this.customerINDdata.state_code
        );
        if (responseData.data.status_code === 200 && Array.isArray(responseData.data.data)) {
          this.dropdown.city_options = responseData.data.data.map((i) => {
            return {
              text: i.name,
              value: i.id,
            };
          });
          this.haveCities = this.dropdown.city_options.length > 0;
        }
      } catch (e) {
        console.error(e);
      }
    },
    async getSourceOfFunds() {
      try {
        const responseData = await commonService.getparameterdropdowns("SOF");
        if (responseData.data.status_code === 200) {
          this.dropdown.sourceofFunds_list = responseData.data.data.map((i) => {
            return { text: i.value, value: i.value_code };
          });
        }

        console.log("Funds", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getparameterdropdowns(code) {
      try {
        const responseData = await commonService.getparameterdropdowns(code);
        if (responseData.data.status_code === 200) {
          this.dropdown.ID_types = responseData.data.data.map((i) => {
            return { text: i.value, value: i.value_code };
          });
        }

        console.log("Funds", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getzipcodes() {
      try {
        const responseData = await commonService.getZipCodes();
        if (responseData.data.status_code === 200) {
          this.dropdown.zipcodes = responseData.data.data;
        }

        console.log("zipcodes", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getOccupation() {
      try {
        const responseData = await commonService.getparameterdropdowns("OCC");
        if (responseData.data.status_code === 200) {
          this.dropdown.occupation_list = responseData.data.data.map((i) => {
            return { text: i.value, value: i.value_code };
          });
        }

        console.log("occupation", responseData);
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>
<style lang="css">
.required:after {
  content: " *";
  color: red;
}
</style>
